import React, { useState, useEffect, useMemo } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import CustomToastComponent from "../ToastComponent/CustomToastComponent";
import { useAppConfig } from "../../providers/AppConfigProvider";
import { getCannedMsgAPI, storeCannnedMsgDetails } from "../../services/cannedMsg";
import { storeTranscriptDetails } from "../../services/chatTranscriptService";
import "./CannedResponse.css";
import { EVENT_CONTENT_TYPE } from '../../utility/util';
import { SITE_MAP_ENUM } from "../../utility/util"
import { EventEmitter } from "../../utility/events";
import { coupon, YOUYUBE_VIDEOS } from '../../constants/DefaultValues';
const FILE = "CannedResponse";
let _ = require('lodash');




const localDateFormat = (val) => {
    return new Date(Date.parse(val)).toLocaleDateString()
};

const CannedResponse = ({ contactSet }) => {
    console.log("CannedResponse loaded", contactSet);

    const { selectContact, endContactId, cannedMsgSet } = useAppConfig();
    console.log("Canned response provider", selectContact, endContactId)
    const notificationURL = "https://mso-connect-chat.s3.amazonaws.com/messageTune/Teams-notification.mp3";
    const audioObj = new Audio(notificationURL);

    const [chatClientFirst, setChatClientFirst] = useState(null);
    const [chatClientSecond, setChatClientSecond] = useState(null);
    const [cannedMsgList, setCannedMsgList] = useState([]);
    // const [ cannedMsgSet, setCannedMsgSet] = useState({});

    const [transcriptOne, setTranscriptOne] = useState([]);
    const [transcriptTwo, setTranscriptTwo] = useState([]);

    const [error, setError] = useState(null);
    const [text, setText] = useState("");
    const [currentTextArea, setCurrentTextArea] = useState(null);


    useEffect(() => {
        EventEmitter.subscribe("SEND_MESSAGE", (data) => {
            console.log("SEND_MESSAGE data", data);
            sendCannedMessage(JSON.stringify(data));
        })

        EventEmitter.subscribe("PAYMENT_REQUEST", (data) => {
            console.log("PAYMENT_REQUEST data", data);
            sendCannedMessage(data.REQUEST);
        })
        return () => {
            // unsubscribe("PAYMENT_REQUEST")
            EventEmitter.unsubscribe("PAYMENT_REQUEST");
            EventEmitter.unsubscribe("SEND_MESSAGE");
        }
    });

    const filterAttachment = (chatSession, transcript) => {
        EventEmitter.dispatch("ATTACHMENT_LIST", {
            chat_session: chatSession,
            attachments: _.filter(transcript, { "Type": "ATTACHMENT" })
        })
    }
    useEffect(() => {
        EventEmitter.subscribe("CHECK_ATTACHMENTS", () => {
            console.log("CHECK_ATTACHMENTS", selectContact);
            if (chatClientFirst && chatClientFirst.contactId && (chatClientFirst.contactId === selectContact)) {
                filterAttachment(chatClientFirst, transcriptOne)
            } else if (chatClientSecond && chatClientSecond.contactId && (chatClientSecond.contactId === selectContact)) {
                filterAttachment(chatClientSecond, transcriptTwo)
            } else {
                toast.error('Please select a chat to send message.')
            }
            console.log("TRa1", transcriptOne);
            console.log("TRa2", transcriptTwo);
            console.log("Chat cli1", chatClientFirst);
            console.log("Chat cli2", chatClientSecond);
        })
        return () => {
            EventEmitter.unsubscribe("CHECK_ATTACHMENTS")
        }
    });

    const updateCannedMessageContent = (queue) => {
        let siteEnum = _.find(SITE_MAP_ENUM, function (o) {
            if (Array.isArray(o.value) && (o.value.find(ele => queue.includes(ele)))) {
                return true;
            } else {
                return queue.includes(o.value)
            }
        });
        console.log(siteEnum);
        if (siteEnum && siteEnum.ignore) {
            setCannedMsgList([]);
        } else if (siteEnum && cannedMsgSet[siteEnum['site']]) {
            console.log("siteEnum", cannedMsgSet)
            // let finalRes = 
            setCannedMsgList(cannedMsgSet[siteEnum['site']])
            // setCannedMsgList( [...cannedMsgSet[siteEnum['site']] , ...YOUYUBE_VIDEOS , ...coupon] )
        } else {
            setCannedMsgList([]);
        }

        // if (siteEnum && !siteEnum.ignore) {
        //     setCannedMsgList(cannedMsgSet[siteEnum['site']])
        // }
    };

    async function createChatSession() {

        let connection = Array.from(contactSet).find(e => e.contactId === selectContact);
        if (connection) {
            let contact = connection.contact;
            // const contactsSub = window.connect.contact(contact => {
            //     contact.onAccepted(async () => {
            const cnn = contact.getConnections().find(cnn => cnn.getType() === window.connect.ConnectionType.AGENT);
            const agentChatSession = window.connect.ChatSession.create({
                chatDetails: cnn.getMediaInfo(), // REQUIRED
                options: { // REQUIRED
                    region: "us-east-1", // REQUIRED, must match the value provided to `connect.core.initCCP()`
                },
                type: window.connect.ChatSession.SessionTypes.AGENT, // REQUIRED
                websocketManager: window.connect.core.getWebSocketManager() // REQUIRED
            });
            const { connectCalled, connectSuccess } = await agentChatSession.connect();

            const connectionToken = await cnn.getConnectionToken();
            console.log("connectionToken", connectionToken)

            let agentLdap = ''
            window.connect.agent(function (agent) {
                agentLdap = agent._getData().configuration.username;
            })

            if (chatClientFirst) {
                getChatTranscript(agentChatSession, { "ContentType": EVENT_CONTENT_TYPE.INITIATED }, 2)
                const attributes = contact.getAttributes();
                setChatClientSecond({
                    "contactId": contact.getContactId(),
                    "queue": contact.getQueue().name,
                    "chatClient": agentChatSession,
                    "queueName": attributes.queueName.value,
                    "agentUserName": agentLdap
                });
                updateCannedMessageContent(contact.getQueue().name)
            } else {
                getChatTranscript(agentChatSession, { "ContentType": EVENT_CONTENT_TYPE.INITIATED }, 1)
                const attributes = contact.getAttributes();
                setChatClientFirst({
                    "contactId": contact.getContactId(),
                    "queue": contact.getQueue().name,
                    "chatClient": agentChatSession,
                    "queueName": attributes.queueName.value,
                    "agentUserName": agentLdap
                });
                updateCannedMessageContent(contact.getQueue().name)
            }
            // });
            //}) 

        }


        //return () => connection;
    }

    useEffect(() => {
        /**
         * Get Canned response List based on agetn routing profile
         */
        setCannedMsgList([]);

        // if(!cannedMsgList){

        if (selectContact) {
            // EventEmitter.dispatch("CHECK_PAYMENT_STATUS",{ ContactId : data.ContactId , paymentType : data.Content} );
            sessionStorage.setItem("activeChat", selectContact);

            if (contactSet.size > 0) {
                let queue__name = _.find([...contactSet], { contactId: selectContact });
                // console.log("contactSet", queue__name['queue']);
                if (queue__name) updateCannedMessageContent(queue__name['queue'])
            }
            createChatSession();
        }
        // }
        // else {
        //      sessionStorage.setItem("activeChat", selectContact);
        //         if(contactSet.size > 0) {
        //             let queue__name = _.find([...contactSet], {contactId : selectContact});
        //             updateCannedMessageContent(queue__name['queue'])
        //         }
        // }


    }, [selectContact])


    useEffect(() => {
        if (chatClientFirst && chatClientFirst.contactId) {
            EventEmitter.dispatch('CHAT_CLIENT_FIRST', chatClientFirst)
            const chatClientSession = chatClientFirst.chatClient;
            chatClientSession.onConnectionEstablished(event => {
                alert("Conn 1")
                const { chatDetails } = event;
                console.log("chatClientSession ::: 1", chatDetails)
                toast.success("Connection established 1");
            });

            chatClientSession.onConnectionBroken(event => {
                const { chatDetails } = event;
                console.log("chatClientSession ::: 2", chatDetails)
            });
            chatClientSession.onEnded(event => {
                const { chatDetails, data } = event;
                console.log("chatClientSession ::: 3", chatDetails, data);
                setChatClientFirst(null);
            });

            chatClientSession.onMessage(event => {
                const { chatDetails, data } = event;
                checkPaymentStatus(data)

                // Get transcript and store on DynamoDB
                getChatTranscript(chatClientSession, data, 1);

                if (data.ParticipantRole === "CUSTOMER") {
                    audioObj.play();
                    // For non-focoused chat window message will give the notification 
                    if (chatClientFirst.contactId != sessionStorage.getItem("activeChat")) {
                        toast.custom(<CustomToastComponent
                            title={data.DisplayName}
                            content={data.Content}
                            type="user"
                        />);
                    }
                }
            });

        }
    }, [chatClientFirst])

    useEffect(() => {
        if (chatClientSecond && chatClientSecond.contactId) {
            EventEmitter.dispatch('CHAT_CLIENT_SECOND', chatClientSecond)
            const chatClientSession__ = chatClientSecond.chatClient;
            chatClientSession__.onConnectionEstablished(event => {
                const { chatDetails } = event;
                console.log("chatClientSessionO ::: 1", chatDetails);
                toast.success("Connection established 2");
            });

            chatClientSession__.onConnectionBroken(event => {
                const { chatDetails } = event;
                console.log("chatClientSession__ ::: 2", chatDetails)
            });
            chatClientSession__.onEnded(event => {
                const { chatDetails, data } = event;
                console.log("chatClientSession__ ::: 3", chatDetails, data);
                setChatClientSecond(null);
            });

            chatClientSession__.onMessage(event => {

                const { chatDetails, data } = event;
                checkPaymentStatus(data)
                getChatTranscript(chatClientSession__, data, 2);

                if (data.ParticipantRole === "CUSTOMER") {
                    audioObj.play();

                    // For non-focoused chat window message will give the notification 
                    if (chatClientSecond.contactId != sessionStorage.getItem("activeChat")) {
                        toast.custom(<CustomToastComponent
                            title={data.DisplayName}
                            content={data.Content}
                            type="user"
                        />)
                    }
                }
            });

        }
    }, [chatClientSecond])



    const loadTranscriptRequired = (type) => {
        if (type == EVENT_CONTENT_TYPE.PARTICIPANT_LEFT) {
            return false
        } else if (type == EVENT_CONTENT_TYPE.CHAT_ENDED) {
            return false
        } else if (type === EVENT_CONTENT_TYPE.INITIATED) {
            return true
        } else {
            return true;
        }
    }

    const getChatTranscript = async (chatSession, data, chatNumber) => {
        if (loadTranscriptRequired(data.ContentType)) {
            const transcriptResponse = await chatSession.getTranscript({
                "maxResults": 100,
                "scanDirection": "BACKWARD",
                "sortOrder": "ASCENDING",
                "startPosition": {}
            });
            const { InitialContactId, NextToken, Transcript } = transcriptResponse.data;
            console.log("getChatTranscript", Transcript);
            if (chatNumber == 1) {
                setTranscriptOne(Transcript)
            } else {
                setTranscriptTwo(Transcript)
            }
        } else {
            if (chatNumber == 1) {
                setTranscriptOne(old => [...old, data]);
            } else {
                setTranscriptTwo(old => [...old, data])
            }
        }
    };

    //  After payment success send the event emitter for API fetch
    const checkPaymentStatus = (data) => {
        if (data.ParticipantRole == "CUSTOMER" &&
            ["PAYMENT_SUCCESS", "PAYMENT_FAIL", "PAYMENT_REJECT", "PAYMENT_COLLECTED", "PAYMENT_ERROR"].includes(data.Content)) {
            EventEmitter.dispatch("CHECK_PAYMENT_STATUS", { ContactId: data.ContactId, paymentType: data.Content })
        }
    }

    useEffect(() => {
        if (transcriptOne.length > 0 && chatClientFirst && 'chatClient' in chatClientFirst) {
            storeTranscriptDetails(chatClientFirst.chatClient.controller.initialContactId, transcriptOne)
        }
    }, [transcriptOne])

    useEffect(() => {
        if (transcriptTwo.length > 0 && chatClientSecond && 'chatClient' in chatClientSecond) {
            storeTranscriptDetails(chatClientSecond.chatClient.controller.initialContactId, transcriptTwo)
        }
    }, [transcriptTwo])

    const sendMessgae = async (chatClientDetails, msg, req) => {
        console.log("sendMessgae", req);
        // const sendResponse = await chatSessionSelected.sendMessage({
        //     contentType: "text/plain",
        //     message: "Hello World!"
        // });
        // console.log("sendResponse",sendResponse);
        chatClientDetails.chatClient.controller.sendMessage({
            contentType: "text/plain",
            message: msg
        }).then(response => {
            console.log("Send messgae res", response);
            toast.success("Message sent")
            setCurrentTextArea(null);
            editCannedText({ Id: -1 });

            // Event capturing for Canned messages
            let cannedMsgAttributes = {
                contactId: chatClientDetails.contactId,
                queueName: chatClientDetails.queueName,
                message: msg,
                absoluteTime: response.data.AbsoluteTime,
                messageDate: localDateFormat(response.data.AbsoluteTime),
                agentUserName: chatClientDetails.agentUserName,
                type : req.type ? req.type : '',
                category : req.Category
            }
            storeCannnedMsgDetails(cannedMsgAttributes);

        }).catch(error => {
            console.log("error messgae res", error);
            toast.error("Messgae didn't send")
            setCurrentTextArea(null);
            // editCannedText({Id : -1});
        })



    };

    const sendCannedMessage = (msg, req) => {
        if (chatClientFirst && chatClientFirst.contactId && (chatClientFirst.contactId === selectContact)) {
            sendMessgae(chatClientFirst, msg, req)
        } else if (chatClientSecond && chatClientSecond.contactId && (chatClientSecond.contactId === selectContact)) {
            sendMessgae(chatClientSecond, msg, req)
        } else {
            toast.error('Please select a chat to send message.')
        }
    }

    const validateSendMsg = (msg, item) => {
        if (currentTextArea && (currentTextArea.includes('xxx') || currentTextArea.includes('XXX') || currentTextArea.includes('---') || currentTextArea.includes('___'))) {
            toast.error(`Please replace 'xxx' with value.`)
        } else if (currentTextArea) {
            sendCannedMessage(currentTextArea, item);

        } else if (currentTextArea == null && (msg.includes('xxx') || msg.includes('XXX'))) {
            // setError(`Please replace 'xxx' with value.`);
            toast.error(`Please replace 'xxx' with value.`)
        } else if (currentTextArea == null && (msg.includes('---') || msg.includes('___'))) {
            toast.error(`Please replace '---' or '___' with value.`)
        } else if (item.Category === "VIDEO" || item.Category.toLowerCase() === "image"){
            sendCannedMessage(JSON.stringify(item.MessageType), item);
        } else {
            sendCannedMessage(msg, item);
        }

    }


    const editCannedText = (idToBeUpdate) => {
        // 👇️ passing function to setData method
        setCannedMsgList(prevState => {
            const newState = prevState.map(obj => {
                // 👇️ if id equals 2, update country property
                console.log(obj)
                if (obj.Id === idToBeUpdate.Id) {
                    return { ...obj, edit: !idToBeUpdate.edit };
                }

                // 👇️ otherwise return object as is
                return { ...obj, edit: false };
            });

            return newState;
        }
        );

        setCurrentTextArea(idToBeUpdate.Message);
    }

    useEffect(()=>{
        console.log("cannedMsgSet useEffect",cannedMsgSet, selectContact)
        if(Object.keys(cannedMsgSet).length > 0 && selectContact) {
                if (contactSet.size > 0) {
                    let queue__name = _.find([...contactSet], { contactId: selectContact });
                    if (queue__name) updateCannedMessageContent(queue__name['queue'])
                }
        }
    },[cannedMsgSet]);

    if (cannedMsgList.length > 0) {
        return (
            <>
                <div className={`canned-msg-container`}>
                    <div className="row p-1 container-title">
                        <span>Quick Response</span>
                    </div>
                    <div className='row'>
                        <input
                            spellCheck="true"
                            autoFocus={true}
                            placeholder="Enter key word to search"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            type="text"
                            className="form-control"
                            // onClick={()=>validateSendMsg()}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    <div className="row canned-response-box">
                        <ul className="list-group">
                            {
                                cannedMsgList && cannedMsgList.flatMap(
                                    (item, index) => {
                                        let searchItem = "";
                                        let searchValue = text;
                                        if (text.trim().indexOf('/') == 0) {
                                            searchItem = 'Category'
                                            searchValue = text.trim().slice(1).trim();
                                        } else {
                                            searchItem = 'Message'
                                        }
                                        if (item[searchItem].toLowerCase().includes(searchValue.toLowerCase())) {
                                            return (
                                                <li className="list-group-item canned-response-content" key={item.Id}>
                                                    <div className='canned-content-1'>
                                                        <span className='fw-bolder'>{item.Category} : </span>
                                                        <div className='canned-msg-btn-action-group'>
                                                            {/* <span className='canned-chat-send-msg'>Sending...</span> */}

                                                            {!item.readOnly && 
                                                            <button type="button" className="canned-icon-btn canned-icon-warning " onClick={() => editCannedText(item)} disabled={item.readOnly}>
                                                            edit<i className="fa-solid fa-eraser  ms-1" ></i>
                                                        </button>}
                                                            

                                                            <button type="button" className="canned-icon-btn canned-icon-primary chat-send-icon" onClick={() => validateSendMsg(item.Message, item)}>
                                                                send<i className="fa-solid fa-paper-plane ms-1" ></i>
                                                            </button>

                                                        </div>

                                                    </div>
                                                    {item.edit ?
                                                        <textarea id={item.id} defaultValue={item.Message} className="canned-text-area mt-1" rows={Math.round(item.Message.length / 50)}
                                                            onChange={(e) => setCurrentTextArea(e.target.value)}>
                                                        </textarea>
                                                        : <span>{item.Message}</span>
                                                    }
                                                </li>
                                            )
                                        }
                                    }
                                )
                            }
                        </ul>
                    </div>
                    {error ? <div className='cannedMsgError'>{error}</div> : ""}
                </div>
            </>
        )
    }
    else {
        //    return (<div className='loader'></div>);
        // return (<div className='row' style={{ "background": "white" }}><div className='col-12'></div></div>)
    return(
            <div className="contact-details-root h-100">
            <div className="p-1 container-title">
                <span>Quick Response</span>
            </div>
                <div className="no-contact-details">
                <em>No details</em>
            </div>
            </div>
        )
    }
}


export default CannedResponse;